import React from "react";

import { useDictionary } from "hooks";
import { useRuleBuilderContext } from "containers/Rules/context/useRuleBuilderContext";

import ConditionOperand from "../ConditionOperand/ConditionOperand";
import AndOrComponent from "../AndOrComponent/AndOrComponent";

import styles from "./styles.css";

const RuleGroup = ({ group, isEditing, multiGroup, index }) => {
    const dictionary = useDictionary("ruleBuilder");
    const { addOperand, setEditingOperand } = useRuleBuilderContext();

    const addNewOperand = () => {
        addOperand({ group });
    };

    return (
        <>
            <AndOrComponent
                operand={group}
                isEditing={isEditing}
                index={index}
                className={"groupOperator"}
            />
            <div className={`${multiGroup ? styles.ruleGroup : ""}`}>
                {multiGroup && (
                    <div className={styles.ruleGroupHeader}>
                        {dictionary.conditionBuilder.groupLabel ?? "Group"}{" "}
                        {index + 1}
                    </div>
                )}

                {(group.operands ?? []).map((operand, index) => (
                    <ConditionOperand
                        setEditingOperand={setEditingOperand}
                        operand={operand}
                        isEditing={isEditing}
                        addOperand={addNewOperand}
                        index={index}
                        showAddLogicButton={index === group.operands.length - 1}
                    />
                ))}
            </div>
        </>
    );
};

export default RuleGroup;
